import loadable from '@loadable/component';
const modelsManifestPath = './src/models/models.manifest.ts';
export const manifest = {
  DigitalProfileWrapper: {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "DigitalProfileWrapper";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "DigitalProfileWrapper" */
          '.'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak(".");
            }

            return eval('require.resolve')(".");
          }

        }, {
          resolveComponent: m => m.DigitalProfileWrapper
        })
      }
    }
  }
};